import React from 'react';
import { VendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorIconV3 } from '../../util/getVendorIconV3';
import { VendorIconWrapper } from './VendorIcon.styles';

export type VendorIconProps = {
  vendorTaxonomyKey: VendorTaxonomyKey;
  iconWidth?: number;
  iconHeight?: number;
} & React.HTMLAttributes<HTMLDivElement>;

const VendorIcon = (props: VendorIconProps) => {
  const { vendorTaxonomyKey, iconHeight = 32, iconWidth = 32, className, ...rest } = props;
  const Icon = getVendorIconV3(vendorTaxonomyKey);
  return (
    <VendorIconWrapper className={className} iconWidth={iconWidth} {...rest}>
      <Icon width={iconWidth} height={iconHeight} />
    </VendorIconWrapper>
  );
};

export default VendorIcon;
